import { alexforbesBrand } from '../brand/alexforbes';

const c = alexforbesBrand.colors;

export const TRADE_STATUSES = {
  DRAFT: 'draft',
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  PENDING_SETTLEMENT: 'pending_settlement',
  SETTLED: 'settled',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const TRADE_STATUS_LABELS = {
  [TRADE_STATUSES.DRAFT]: 'Draft',
  [TRADE_STATUSES.PENDING_APPROVAL]: 'Pending Approval',
  [TRADE_STATUSES.APPROVED]: 'Approved',
  [TRADE_STATUSES.PENDING_SETTLEMENT]: 'Pending Settlement',
  [TRADE_STATUSES.SETTLED]: 'Settled',
  [TRADE_STATUSES.REJECTED]: 'Rejected',
  [TRADE_STATUSES.CANCELLED]: 'Cancelled',
};

export const TRADE_STATUS_COLORS = {
  [TRADE_STATUSES.DRAFT]: c.neutral,
  [TRADE_STATUSES.PENDING_APPROVAL]: c.orangeLight,
  [TRADE_STATUSES.APPROVED]: c.orange,
  [TRADE_STATUSES.PENDING_SETTLEMENT]: c.orangeLight,
  [TRADE_STATUSES.SETTLED]: c.orange,
  [TRADE_STATUSES.REJECTED]: c.error,
  [TRADE_STATUSES.CANCELLED]: c.neutral,
};
